import type { Fallacy } from "./types";
import { createStory } from "./types";

export const zeroSumBias: Fallacy = {
    id: "zero-sum-bias",
    name: "Zero-Sum Bias",
    emoji: "⚖️",
    category: "Jebakan Strategi",
    description: "Menganggap setiap situasi sebagai **kalah-menang**: \"Kalau dia untung, berarti aku rugi.\"",
    tldr: "\"Keberhasilan orang lain = kerugianku\" — padahal banyak situasi di mana semua bisa menang.",
    detail: "Zero-Sum Bias adalah kecenderungan menganggap setiap situasi sebagai permainan zero-sum, di mana **keuntungan satu pihak selalu berarti kerugian pihak lain**. Padahal sebagian besar interaksi manusia bersifat positive-sum — semua pihak bisa diuntungkan.\n\nBias ini umum di dunia kerja: rekan dapat promosi, kita otomatis merasa \"dirugikan\" — seolah slot promosi adalah kue tetap. Di konteks sosial-politik, bias ini mendorong narasi \"kita vs mereka\" dan anggapan bahwa kesuksesan pihak lain berarti kemunduran kita.\n\nAkarnya adalah ketidakmampuan melihat bahwa **\"kue\" bisa diperbesar**. Inovasi, kolaborasi, dan pertukaran menciptakan nilai baru. Menyadari bahwa dunia bukan zero-sum adalah langkah pertama menuju pemikiran yang lebih strategis.",
    story: createStory("Zero-Sum Bias", "⚖️", {
      hook: {
        title: "Temen kamu dapet promosi.",
        body: "Seneng buat dia... atau diam-diam kesel karena ngerasa \"jatah kamu diambil\"?",
      },
      convo: {
        claim: "Temen kantor aku dapet promosi. Aku kesel sih sebenernya, **kalau dia naik berarti kesempatan aku berkurang** kan.",
        response: "Promosi bukan slot terbatas. **Dia naik bukan berarti jalan kamu tertutup.**",
      },
      reveal: {
        body: "Kamu nganggep hidup ini **selalu kalah-menang**. Kalau dia untung, kamu pasti rugi. Seolah-olah kue-nya cuma segitu-gitu aja.",
      },
      insight: {
        title: "Faktanya?",
        body: "Kue-nya **bisa diperbesar**. Temen kamu naik jabatan bukan berarti jatah kamu hilang — justru bisa buka jalan buat kamu juga.",
      },
      engagement: {
        title: "Pernah ngerasa kesel pas orang lain sukses? 😬",
        body: "Di kerjaan atau di bisnis? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["prisoners-dilemma", "false-dilemma", "tragedy-of-commons"],
  };
